import axios from 'src/utils/axios';
export const GET_TOTAL_STAFF = '@user/get-total-staff';
export const GET_ALL_STAFF = '@user/get-all-staff';
export const ADD_STAFF = '@user/add-staff';
export const UPDATE_STAFF = '@user/update-staff';
export const DELETE_STAFF = '@user/delete-staff';
export const RESET_PASSWORD = '@user/reset-password';

export function addStaffsByWorkspace(staffEmails, workspaceId) {
  const request = axios.post(`/api/staff/addStaffsToWorkspace`, {
    staffEmails,
    workspaceId
  });
  return dispatch => {
    console.log(`Add to ${workspaceId}: ${JSON.parse(staffEmails).join(', ')}`);
    request.then(response => dispatch(getAllStaff(workspaceId)));
  };
}

export function getTotalStaff() {
  const request = axios.get(`/api/staff/all`);

  return dispatch => {
    request.then(response =>
      dispatch({
        type: GET_TOTAL_STAFF,
        payload: response.data
      })
    );
  };
}

export function getAllStaff(workspaceId) {
  const request = axios.post(`/api/staff/all`, { workspaceId });

  return dispatch => {
    request.then(response =>
      dispatch({
        type: GET_ALL_STAFF,
        payload: response.data
      })
    );
  };
}
export function addOneStaff(staff, workspaceId) {
  const request = axios.post(`/api/staff/add`, { staff, workspaceId });
  return dispatch => {
    request.then(response =>
      dispatch({
        type: ADD_STAFF,
        payload: response.data
      })
    );
  };
}

export function updateStaff(staff) {
  const request = axios.put(`/api/staff/update`, {
    staff
  });
  return dispatch => {
    request.then(response =>
      dispatch({
        type: UPDATE_STAFF,
        payload: response.data
      })
    );
  };
}

export function deleteStaffs(id) {
  const request = axios.delete(`/api/staff/delete/${id}`);

  return dispatch => {
    request.then(() =>
      dispatch({
        type: DELETE_STAFF,
        payload: { id }
      })
    );
  };
}
export function resetPassword(staff) {
  const request = axios.put(`/api/staff/resetPassword`, { staff });
  return dispatch => {
    request.then(response =>
      dispatch({
        type: RESET_PASSWORD,
        payload: response.data
      })
    );
  };
}
